import { useHandlers } from '../../../context/page-context';
import type { CompaniesApiContract } from '../api';

export function useCompaniesApi(): { companiesApi: CompaniesApiContract } {
  const { apis } = useHandlers();
  return { companiesApi: apis.companies };
}
